import { Component, OnInit, HostListener, Inject, PLATFORM_ID, Pipe, PipeTransform, ViewEncapsulation, viewChild, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { JobsidepreviewModule, ReqSidePreviewRequest, ReqSidePreviewResponse,MultipleSiteIdsInfo } from '../../Models/job-side-preview.model';
import { JobSidePreviewComponent } from '../job-side-preview/job-side-preview.component';
import { JobsidepreviewService } from '../../Services/jobsidepreview.service';
import { ViewChild } from '@angular/core';
import { V } from '@angular/cdk/scrolling-module.d-ud2XrbF8';
@Component({
  selector: 'app-multisiteinfo',
  standalone: true,
  imports: [ MatButtonModule, CommonModule],
  templateUrl: './multisiteinfo.component.html',
  styleUrl: './multisiteinfo.component.scss'

})
export class MutlisiteinfoComponent implements OnInit, OnChanges {

  constructor(
    private jobsidepreviewService: JobsidepreviewService,
    @Inject(PLATFORM_ID) private platformId: Object,

  ) { }

  ngOnInit(): void {
   
    this.scrollToActiveSite();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['ActiveSiteId'] || changes['multiplesiteidsinfo']) {
      setTimeout(() => this.scrollToActiveSite());
    }
  }

  scrollToActiveSite() {
    if (!this.multiplesiteidsinfo || !this.ActiveSiteId || this.multiplesiteidsinfo.length === 0) return;
    
    const activeIndex = this.multiplesiteidsinfo.findIndex(s => s.SiteId == this.ActiveSiteId);
    if (activeIndex !== -1) {
      this.visibleSitesStart = Math.floor(activeIndex / this.sitesPageSize) * this.sitesPageSize;
    }
  }
  
  visibleSitesStart: number = 0;
  sitesPageSize: number = 2;
  reqsidepreviewrequest!: ReqSidePreviewRequest;
  requestQuestionresponses: any;
  jdpreviewloading: boolean = false;
  NoStieIdSelected: boolean = false;
  isDarkMode: boolean = false;
  siteidresponses: any;
  partnerId: string = '';
  senddata: any;


  @Output() siteSelected = new EventEmitter<string>();

  @Input() ActiveSiteId: string = '';
  
  private _multiplesiteidsinfo: MultipleSiteIdsInfo[] = [];
  
  @Input() set multiplesiteidsinfo(data: MultipleSiteIdsInfo[]) {
    this._multiplesiteidsinfo = data || [];
    this.scrollToActiveSite();
  }

  get multiplesiteidsinfo(): MultipleSiteIdsInfo[] {
    return this._multiplesiteidsinfo;
  }
  switchsite(siteId: string) {
    this.ActiveSiteId = siteId;
    this.siteSelected.emit(siteId);
  }

  nextVisibleSites() {
    if (this.visibleSitesStart + this.sitesPageSize < this.multiplesiteidsinfo.length) {
      this.visibleSitesStart += this.sitesPageSize;
    }
  }

  prevVisibleSites() {
    if (this.visibleSitesStart > 0) {
      this.visibleSitesStart -= this.sitesPageSize;
    }
  }
}
